import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../components/layout/MainLayout';

import Button from '../../components/ui/Button';
import StatCard from './components/StatCard';
import ApplicationStatusCard from './components/ApplicationStatusCard';
import JobRecommendationCard from './components/JobRecommendationCard';
import NotificationPanel from './components/NotificationPanel';
import UpcomingDeadlineCard from './components/UpcomingDeadlineCard';
import QuickActionCard from './components/QuickActionCard';
import ActivityTimelineItem from './components/ActivityTimelineItem';
import AIJobMatching from './components/AIJobMatching';
import SmartCandidateScreening from './components/SmartCandidateScreening';
import SkillGapAnalysis from './components/SkillGapAnalysis';

const RoleBasedDashboard = () => {
  const navigate = useNavigate();
  const [currentRole] = useState('student');
  const [greeting, setGreeting] = useState('');
  const [activeAITab, setActiveAITab] = useState('job-matching');

  useEffect(() => {
    const hour = new Date()?.getHours();
    if (hour < 12) setGreeting('Good Morning');else
    if (hour < 17) setGreeting('Good Afternoon');else
    setGreeting('Good Evening');
  }, []);

  const studentStats = [
  {
    title: "Applications Sent",
    value: "24",
    change: "+12.5%",
    changeType: "positive",
    icon: "Send",
    iconColor: "var(--color-primary)",
    trend: "up"
  },
  {
    title: "Profile Views",
    value: "156",
    change: "+8.3%",
    changeType: "positive",
    icon: "Eye",
    iconColor: "var(--color-success)",
    trend: "up"
  },
  {
    title: "Interviews Scheduled",
    value: "3",
    change: "+2",
    changeType: "positive",
    icon: "Calendar",
    iconColor: "var(--color-accent)",
    trend: "up"
  },
  {
    title: "Saved Jobs",
    value: "18",
    change: "-2",
    changeType: "negative",
    icon: "Bookmark",
    iconColor: "var(--color-warning)",
    trend: "down"
  }];


  const applications = [
  {
    id: 1,
    position: "Frontend Developer Intern",
    company: "Tech Innovations Pvt Ltd",
    companyLogo: "https://images.unsplash.com/photo-1715950227433-4cd241cc50b2",
    companyLogoAlt: "Modern tech company office building with glass facade and blue sky background",
    location: "Bangalore, Karnataka",
    type: "Internship",
    stipend: "₹15,000/month",
    status: "Under Review",
    appliedDate: "2026-01-28T10:30:00"
  },
  {
    id: 2,
    position: "UI/UX Design Intern",
    company: "Creative Solutions India",
    companyLogo: "https://images.unsplash.com/photo-1683192192377-c5115a0cd49e",
    companyLogoAlt: "Contemporary corporate building with geometric architecture and reflective windows",
    location: "Mumbai, Maharashtra",
    type: "Internship",
    stipend: "₹12,000/month",
    status: "Interview Scheduled",
    appliedDate: "2026-01-25T14:20:00"
  },
  {
    id: 3,
    position: "Data Analytics Intern",
    company: "DataTech Solutions",
    companyLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_17b7471c4-1769473684966.png",
    companyLogoAlt: "Professional office workspace with modern furniture and natural lighting through large windows",
    location: "Pune, Maharashtra",
    type: "Internship",
    stipend: "₹18,000/month",
    status: "Shortlisted",
    appliedDate: "2026-01-22T09:15:00"
  }];


  const recommendedJobs = [
  {
    id: 1,
    title: "React Developer Intern",
    company: "WebTech Innovations",
    companyLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_130d53363-1769451772821.png",
    companyLogoAlt: "Modern startup office with open workspace and collaborative environment",
    location: "Hyderabad, Telangana",
    type: "Internship",
    stipend: "₹20,000/month",
    skills: ["React", "JavaScript", "HTML/CSS", "Git"],
    applicants: 45,
    postedDate: "2026-02-02T08:00:00",
    isNew: true
  },
  {
    id: 2,
    title: "Full Stack Development Intern",
    company: "Digital Dynamics",
    companyLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_17ef18b31-1768149206338.png",
    companyLogoAlt: "High-rise corporate office building with modern glass and steel architecture",
    location: "Delhi NCR",
    type: "Internship",
    stipend: "₹25,000/month",
    skills: ["Node.js", "React", "MongoDB", "Express"],
    applicants: 67,
    postedDate: "2026-02-01T10:30:00",
    isNew: true
  },
  {
    id: 3,
    title: "Mobile App Development Intern",
    company: "AppCraft Technologies",
    companyLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_1b2928fe2-1767606264300.png",
    companyLogoAlt: "Contemporary tech company workspace with creative design and modern amenities",
    location: "Chennai, Tamil Nadu",
    type: "Internship",
    stipend: "₹18,000/month",
    skills: ["React Native", "JavaScript", "Firebase"],
    applicants: 32,
    postedDate: "2026-01-30T15:45:00",
    isNew: false
  }];


  const notifications = [
  {
    id: 1,
    type: "interview",
    title: "Interview Scheduled",
    message: "Your interview with Creative Solutions India for UI/UX Design Intern position is scheduled for 05/02/2026 at 2:00 PM. Please check your email for meeting details.",
    timestamp: "2026-02-03T09:30:00",
    read: false,
    actionLabel: "View Details"
  },
  {
    id: 2,
    type: "application",
    title: "Application Shortlisted",
    message: "Congratulations! Your application for Data Analytics Intern at DataTech Solutions has been shortlisted. The hiring team will contact you soon.",
    timestamp: "2026-02-02T16:45:00",
    read: false,
    actionLabel: "View Application"
  },
  {
    id: 3,
    type: "deadline",
    title: "Application Deadline Approaching",
    message: "The application deadline for Backend Developer Intern at CloudTech Systems is in 2 days. Complete your application before 05/02/2026.",
    timestamp: "2026-02-02T10:20:00",
    read: true,
    actionLabel: "Apply Now"
  },
  {
    id: 4,
    type: "system",
    title: "Profile Completion",
    message: "Your profile is 85% complete. Add your project portfolio and certifications to increase your visibility to employers.",
    timestamp: "2026-02-01T14:00:00",
    read: true,
    actionLabel: "Complete Profile"
  },
  {
    id: 5,
    type: "message",
    title: "New Message from Recruiter",
    message: "You have received a message from Tech Innovations Pvt Ltd regarding your Frontend Developer Intern application.",
    timestamp: "2026-02-01T11:30:00",
    read: true,
    actionLabel: "Read Message"
  }];


  const upcomingDeadlines = [
  {
    id: 1,
    title: "Backend Developer Intern",
    company: "CloudTech Systems",
    date: "2026-02-05T23:59:59"
  },
  {
    id: 2,
    title: "Python Developer Intern",
    company: "AI Solutions India",
    date: "2026-02-07T23:59:59"
  },
  {
    id: 3,
    title: "DevOps Intern",
    company: "Infrastructure Pro",
    date: "2026-02-10T23:59:59"
  },
  {
    id: 4,
    title: "Quality Assurance Intern",
    company: "TestTech Labs",
    date: "2026-02-12T23:59:59"
  }];


  const quickActions = [
  {
    title: "Search Jobs",
    description: "Browse through thousands of job and internship opportunities",
    icon: "Search",
    iconColor: "var(--color-primary)",
    path: "/job-search-application"
  },
  {
    title: "Update Profile",
    description: "Keep your profile updated to attract more employers",
    icon: "User",
    iconColor: "var(--color-success)",
    path: "/student-profile-management"
  },
  {
    title: "View Applications",
    description: "Track the status of all your job applications",
    icon: "FileText",
    iconColor: "var(--color-accent)",
    path: "/role-based-dashboard"
  },
  {
    title: "Skill Assessment",
    description: "Take skill tests to showcase your expertise",
    icon: "Award",
    iconColor: "var(--color-warning)",
    path: "/role-based-dashboard"
  }];


  const recentActivities = [
  {
    id: 1,
    type: "application",
    title: "Applied for Frontend Developer Intern",
    description: "Submitted application to Tech Innovations Pvt Ltd",
    timestamp: "2026-02-03T10:30:00"
  },
  {
    id: 2,
    type: "profile",
    title: "Profile Updated",
    description: "Added new skills: React, TypeScript, Tailwind CSS",
    timestamp: "2026-02-02T15:20:00"
  },
  {
    id: 3,
    type: "interview",
    title: "Interview Completed",
    description: "Attended interview with Creative Solutions India",
    timestamp: "2026-02-01T14:00:00"
  },
  {
    id: 4,
    type: "document",
    title: "Resume Updated",
    description: "Uploaded new version of resume with recent projects",
    timestamp: "2026-01-31T11:45:00"
  },
  {
    id: 5,
    type: "message",
    title: "Message Sent",
    description: "Replied to recruiter from DataTech Solutions",
    timestamp: "2026-01-30T16:30:00"
  }];


  return (
    <MainLayout>
      <div className="space-y-6 md:space-y-8">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-card-foreground mb-2">
              {greeting}, Aritra Dasgupta! 👋
            </h1>
            <p className="text-sm md:text-base text-muted-foreground">
              Here's what's happening with your job search today
            </p>
          </div>
          <Button
            variant="default"
            iconName="Search"
            iconPosition="left"
            onClick={() => navigate('/job-search-application')}
            className="w-full sm:w-auto">

            Search Jobs
          </Button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {studentStats?.map((stat, index) =>
          <StatCard key={index} {...stat} />
          )}
        </div>

        {/* AI Features Section */}
        <div className="bg-gradient-to-r from-blue-50 via-purple-50 to-pink-50 rounded-xl border-2 border-blue-200 p-6">
          <div className="mb-6">
            <h2 className="text-2xl font-heading font-bold text-gray-900 mb-2">
              🤖 AI-Powered Career Tools
            </h2>
            <p className="text-gray-600">
              Leverage artificial intelligence to accelerate your job search and career growth
            </p>
          </div>

          {/* AI Feature Tabs */}
          <div className="flex flex-wrap gap-2 mb-6">
            <button
              onClick={() => setActiveAITab('job-matching')}
              className={`px-4 py-2 rounded-lg font-medium transition-all ${
              activeAITab === 'job-matching' ? 'bg-blue-600 text-white shadow-md' : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-200'}`
              }>

              🎯 AI Job Matching
            </button>
            <button
              onClick={() => setActiveAITab('candidate-screening')}
              className={`px-4 py-2 rounded-lg font-medium transition-all ${
              activeAITab === 'candidate-screening' ? 'bg-purple-600 text-white shadow-md' : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-200'}`
              }>

              📄 Smart Screening
            </button>
            <button
              onClick={() => setActiveAITab('skill-gap')}
              className={`px-4 py-2 rounded-lg font-medium transition-all ${
              activeAITab === 'skill-gap' ? 'bg-pink-600 text-white shadow-md' : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-200'}`
              }>

              📊 Skill Gap Analysis
            </button>
          </div>

          {/* AI Feature Content */}
          <div>
            {activeAITab === 'job-matching' && <AIJobMatching />}
            {activeAITab === 'candidate-screening' && <SmartCandidateScreening />}
            {activeAITab === 'skill-gap' && <SkillGapAnalysis />}
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          <div className="lg:col-span-2 space-y-6">
            <div>
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-xl md:text-2xl font-heading font-semibold text-card-foreground">
                  Recent Applications
                </h2>
                <button className="text-sm text-primary hover:text-primary/80 transition-smooth">
                  View All
                </button>
              </div>
              <div className="space-y-4">
                {applications?.map((application) =>
                <ApplicationStatusCard key={application?.id} application={application} />
                )}
              </div>
            </div>

            <div>
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-xl md:text-2xl font-heading font-semibold text-card-foreground">
                  Recommended for You
                </h2>
                <button className="text-sm text-primary hover:text-primary/80 transition-smooth">
                  View All
                </button>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 gap-4 md:gap-6">
                {recommendedJobs?.map((job) =>
                <JobRecommendationCard key={job?.id} job={job} />
                )}
              </div>
            </div>

            <div>
              <h2 className="text-xl md:text-2xl font-heading font-semibold text-card-foreground mb-4">
                Quick Actions
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {quickActions?.map((action, index) =>
                <QuickActionCard key={index} {...action} />
                )}
              </div>
            </div>
          </div>

          <div className="space-y-6">
            <NotificationPanel notifications={notifications} />

            <div className="bg-card rounded-xl border border-border shadow-warm-sm p-4 md:p-6">
              <h3 className="text-lg md:text-xl font-heading font-semibold text-card-foreground mb-4">
                Upcoming Deadlines
              </h3>
              <div className="space-y-3">
                {upcomingDeadlines?.map((deadline) =>
                <UpcomingDeadlineCard key={deadline?.id} deadline={deadline} />
                )}
              </div>
            </div>

            <div className="bg-card rounded-xl border border-border shadow-warm-sm p-4 md:p-6">
              <h3 className="text-lg md:text-xl font-heading font-semibold text-card-foreground mb-4">
                Recent Activity
              </h3>
              <div className="space-y-2">
                {recentActivities?.map((activity, index) =>
                <ActivityTimelineItem
                  key={activity?.id}
                  activity={activity}
                  isLast={index === recentActivities?.length - 1} />

                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>);

};

export default RoleBasedDashboard;